<template>
  <div class="mt-4">
    <h4 class="mb-4">Check Completeness</h4>

    <CompletenessReport
      :statistics="statistics"
      :group-by-options="groupByOptions"
      :group-by.sync="groupBy"
      :is-busy.sync="isBusy"
    >
    </CompletenessReport>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import CompletenessReport from "@/components/CompletenessReport.vue";
import { CompletenessStatistic } from "@/entities/CompletenessStatistic";
import { HttpHandler } from "@/http/HttpHandler";
import store from "@/store/index";

@Component({
  components: {
    CompletenessReport
  }
})
export default class ExpertReports extends Vue {
  groupByOptions = ["Branch", "Treatment"];
  groupBy: string = this.groupByOptions[0];
  isBusy: boolean = false;

  statistics: CompletenessStatistic[] | void = [];

  async created() {
    await this.loadData();
  }

  @Watch("groupBy")
  async onGroupByChanged(newGroupBy: string) {
    this.groupBy = newGroupBy;
    await this.loadData();
  }

  async loadData() {
    const httpHandler = new HttpHandler(store);
    this.isBusy = true;
    this.statistics = await httpHandler
      .getExpertStatistic(this.groupBy)
      .catch(e => {
        this.isBusy = false;
        console.error(e);
      });
    this.isBusy = false;
  }
}
</script>

<style scoped></style>
